// export class Asset {
//   public readonly decimals: number;
//   public readonly assetId: string;
//   constructor(assetId) {}
// }
export const stringIdEquals = (a, b) => a.id === b.id;
//# sourceMappingURL=Asset.js.map